import React from 'react'
import { Button, Dropdown, Menu, MenuProps } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { useIsCompactMenu } from 'shared/hooks/useIsCompactMenu'
import { useLogoutConfirm } from 'shared/hooks/useLogoutConfirm'
import styles from './ActionsWrapper.module.scss'

// пункт бокового меню, который не ведёт на маршрут, а спрашивает подтверждение выхода
export const LOGOUT_MENU_KEY = 'logout'

interface IAnchorsWrapperProps {
  links: MenuProps['items']
}

export const ActionsWrapper: React.FC<IAnchorsWrapperProps> = ({
  links
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const confirmLogout = useLogoutConfirm()
  const isCompactMenu = useIsCompactMenu()
  const [current, setCurrent] = React.useState('')

  React.useEffect(() => {
    setCurrent(location.pathname.split('/')[2])
  }, [location.pathname])

  const onClick: MenuProps['onClick'] = (e) => {
    if (e.key === LOGOUT_MENU_KEY) {
      return confirmLogout()
    }
    setCurrent(e.key)
    navigate(e.key)
  }

  const currentLink = links?.find(
    (link) => link && 'key' in link && link.key === current
  )
  const currentLabel =
    currentLink && 'label' in currentLink ? currentLink.label : 'Разделы'

  return (
    <div className={styles.sideLayout}>
      {isCompactMenu ? (
        // autoAdjustOverflow отключён, иначе на низком экране меню
        // переворачивается вверх и закрывает саму кнопку
        <Dropdown
          trigger={['click']}
          placement='bottomRight'
          autoAdjustOverflow={false}
          overlayStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
          menu={{ items: links, selectedKeys: [current], onClick }}
        >
          <Button size='large' block className={styles.sectionButton}>
            <span className={styles.sectionLabel}>{currentLabel}</span>
            <DownOutlined />
          </Button>
        </Dropdown>
      ) : (
        <Menu
          mode='inline'
          items={links}
          selectedKeys={[current]}
          onClick={onClick}
          className={classNames('side-menu', styles.menu)}
        />
      )}
      <div className={classNames('side-content', styles.content)}>
        <Outlet />
      </div>
    </div>
  )
}
